export default __webpack_public_path__ + "static/media/art-pro-slt-3.3c23d81c.png";